import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import moment from "moment";
import { Row, Spin } from "components/common";
import { callPostApi } from "utils/api";
import { Wrapper, calenderStyles } from "./PayRole.styled";
import { HiOutlineArrowLongLeft } from "react-icons/hi2";
import { FaCalendarAlt } from "react-icons/fa";
import { LoadingOutlined } from '@ant-design/icons';
import { Popover, Calendar } from "antd";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight, MdArrowDropUp, MdArrowDropDown, MdArrowLeft, MdArrowRight } from "react-icons/md";
import PayRolePayCard from "./PayRolePayCard/PayRolePayCard";

const antIcon = <LoadingOutlined style={{ color: 'black', fontSize: 18 }} spin />;

const PayRole = () => {
    const refPayRoleCard = useRef();
    const [payRolls, setPayRolls] = useState([]);
    const [loader, setLoader] = useState(false);
    const [isPayeePaying, setIsPayeePaying] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    const [selectedDate, setSelectedDate] = useState(moment());
    const [selectedExpansion, setSelectedExpansion] = useState();
    const [selectedExpansionDetails, setSelectedExpansionDetails] = useState();
    const [selectedAvaiableUser, setSelectedAvaiableUser] = useState({ index: -1, id: null });
    const [selectedPayeePayrols, setSelectedPayeePayrols] = useState();
    const [selectedPayeeAmount, setSelectedPayeeAmount] = useState(0);
    const [selectedPayeeToPay, setSelectedPayeeToPay] = useState([]);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    const disableDatesFromNow = (date) => moment().isBefore(date);
    const handleCalenderSelect = (date) => {
        setSelectedDate(date);
    };
    const handleChangeLastMonth = () => {
        const month = selectedDate.month() - 1;
        if (month < 0) {
            let newDate = moment().set('month', 11).set('year', selectedDate.year() - 1);
            setSelectedDate(newDate);
        } else {
            let newDate = moment().set('month', month).set('year', selectedDate.year());;
            setSelectedDate(newDate);
        }
    };
    const handleSelectExpansionPanel = (id) => {
        if (!id) {
            resetFields();
        } else {
            setSelectedExpansion(id)
            const filter = payRolls.find((payrol) => payrol.id === id);
            setSelectedExpansionDetails(filter);
            setSelectedAvaiableUser({ index: 0, id: filter.payees.availablePayee[0].id })
            setSelectedPayeePayrols(filter.payees.payeePayrols[0])
        }
    }
    const handleSelectedAvaiableUserByArrow = (dir) => {
        if (dir === 'left') {
            const filter = selectedExpansionDetails.payees.availablePayee[selectedAvaiableUser.index - 1];
            let payrol = selectedExpansionDetails.payees.payeePayrols.find((pay) => pay.id === filter.id);
            setSelectedPayeePayrols(payrol);
            setSelectedAvaiableUser({ index: selectedAvaiableUser.index - 1, id: filter.id });
            setSelectedPayeeAmount(0);
            setSelectedPayeeToPay([]);
            refPayRoleCard.current.closeDropDown();
        } else {
            const filter = selectedExpansionDetails.payees.availablePayee[selectedAvaiableUser.index + 1];
            let payrol = selectedExpansionDetails.payees.payeePayrols.find((pay) => pay.id === filter.id);
            setSelectedPayeePayrols(payrol);
            setSelectedAvaiableUser({ index: selectedAvaiableUser.index + 1, id: filter.id });
            setSelectedPayeeAmount(0);
            setSelectedPayeeToPay([]);
            refPayRoleCard.current.closeDropDown();
        }
    }
    const handleSelectedAvaiableUser = (idx, id) => {
        if (selectedAvaiableUser.id === id) {
            return;
        }
        let payrol = selectedExpansionDetails.payees.payeePayrols.find((pay) => pay.id === id);
        setSelectedPayeePayrols(payrol);
        setSelectedAvaiableUser({ index: idx, id: id });
        setSelectedPayeeAmount(0);
        setSelectedPayeeToPay([]);
        refPayRoleCard.current.closeDropDown();
    }
    const handleCheckBoxAmount = (id, amount) => {
        if (selectedPayeeToPay.includes(id)) {
            const filter = selectedPayeeToPay.filter((pre) => pre !== id);
            setSelectedPayeeToPay(filter);
            setSelectedPayeeAmount((prev) => (prev - amount));
        } else {
            setSelectedPayeeToPay((prev) => ([...prev, id]))
            setSelectedPayeeAmount((prev) => (prev + amount));
        }
    }
    const resetFields = () => {
        setSelectedExpansion(null)
        setSelectedExpansionDetails(null);
        setSelectedAvaiableUser({ index: -1, id: null })
        setSelectedPayeePayrols(null);
        setSelectedPayeeAmount(0);
        setSelectedPayeeToPay([]);
    }
    const content = (
        <div style={calenderStyles.container}>
            <Calendar
                fullscreen={false}
                mode="year"
                disabledDate={disableDatesFromNow}
                onSelect={handleCalenderSelect}
                value={selectedDate}
                headerRender={({ value, type, onChange, onTypeChange }) => {
                    const month = value.month();
                    const year = value.year();
                    return (
                        <div style={calenderStyles.main}>
                            <MdKeyboardArrowLeft size={26} cursor="pointer" onClick={() => {
                                const now = value.clone().month(0).year(year - 1);
                                onChange(now);
                            }} />
                            <div style={calenderStyles.month}>{months[month]} {year}</div>
                            <MdKeyboardArrowRight size={26} cursor="pointer" style={selectedDate.year() === moment().year() ? calenderStyles.disabled : {}} onClick={() => {
                                const now = value.clone().month(0).year(year + 1);
                                onChange(now);
                            }} />
                        </div>
                    )
                }}
            />
        </div>
    );

    // API's
    const callPayRoleApi = () => {
        setLoader(true);
        const payload = {
            date: selectedDate
        }
        callPostApi("/expenses/payroll", payload, (data) => {
            setPayRolls(data);
            resetFields();
            setLoader(false);
            setIsPayeePaying(false);
        }, (err) => {
            setLoader(false);
            console.log(err);
        });
    };
    const callPayeePayApi = () => {
        setIsPayeePaying(true);
        callPostApi("/expenses/pay/to/payroll", selectedPayeeToPay, () => {
            callPayRoleApi();
        }, (err) => {
            setIsPayeePaying(false);
            console.log(err);
        });
    };

    useLayoutEffect(() => {
        function updateSize() {
            if (window.innerWidth <= 991) {
                setIsSmallScreen(true);
            } else {
                return setIsSmallScreen(false);
            }
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => window.removeEventListener("resize", updateSize);
    }, []);
    useEffect(() => {
        callPayRoleApi();
    }, [selectedDate]);

    return (
        <Wrapper isSmall={isSmallScreen}>
            <div className="top-container">
                <div className="page-title">
                    Payroll
                </div>
                <div className="month-selector">
                    <HiOutlineArrowLongLeft size={isSmallScreen ? 22 : 26} cursor="pointer" onClick={handleChangeLastMonth} style={loader ? calenderStyles.disabled : {}} />
                    <span className="text" style={loader ? calenderStyles.disabled : {}}>{months[selectedDate.month()]} {selectedDate.year()}</span>
                    <Popover content={content} placement="bottomRight" trigger="click">
                        <FaCalendarAlt size={isSmallScreen ? 26 : 30} cursor="pointer" style={loader ? calenderStyles.disabled : {}} />
                    </Popover>
                </div>
            </div>
            <div className="content-container">
                {loader ? (
                    <div className="loader-div">
                        <Spin size="large" />
                    </div>
                ) : (
                    <>
                        {payRolls && payRolls.length ? (<div className="payrol-container">
                            {payRolls.map((payrol, index) => (
                                <div key={payrol.id} className="expansion-panel">
                                    <div className="expansion-panel-header" style={selectedExpansion === payrol.id ? calenderStyles.selected : calenderStyles.notSelected}>
                                        <div className="text-title">Week {index + 1}</div>
                                        <div className="text-title-end">
                                            <div className="week-dates">{moment(payrol.dates.start).format('Do MMMM')} to {moment(payrol.dates.end).format('Do MMMM')}</div>
                                            {payrol.payees.payeePayrols && payrol.payees.payeePayrols.length ? (<div className="expansion-icon">
                                                {selectedExpansion === payrol.id ? (
                                                    <MdArrowDropUp size={isSmallScreen ? 26 : 30} cursor="pointer" onClick={() => handleSelectExpansionPanel('')} />
                                                ) : (
                                                    <MdArrowDropDown size={isSmallScreen ? 26 : 30} cursor="pointer" onClick={() => handleSelectExpansionPanel(payrol.id)} />
                                                )}
                                            </div>) : (<></>)}
                                        </div>
                                    </div>
                                    {payrol.payees.payeePayrols && payrol.payees.payeePayrols.length && selectedExpansion === payrol.id ? (
                                        <div className="expansion-panel-body">
                                            {payrol.payees.availablePayee && payrol.payees.availablePayee.length ? (
                                                <div className="avaiable-payees">
                                                    <MdArrowLeft size={isSmallScreen ? 26 : 30} cursor="pointer" style={!selectedAvaiableUser.index || selectedAvaiableUser.index <= 0 ? calenderStyles.disabled : {}} onClick={() => handleSelectedAvaiableUserByArrow('left')} />
                                                    <div className="avaiable-payeeList">
                                                        {payrol.payees.availablePayee.map((available, idx) => (
                                                            <div className="avaiable-payeeList-box" style={selectedAvaiableUser.id === available.id ? calenderStyles.selected : calenderStyles.notSelected} onClick={() => handleSelectedAvaiableUser(idx, available.id)}>
                                                                {available.name}
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <MdArrowRight size={isSmallScreen ? 26 : 30} cursor="pointer" style={selectedAvaiableUser.index >= payrol.payees.availablePayee.length - 1 ? calenderStyles.disabled : {}} onClick={() => handleSelectedAvaiableUserByArrow('right')} />
                                                </div>
                                            ) : (<></>)}

                                            {payrol.payees.payeePayrols && payrol.payees.payeePayrols.length ? (
                                                <div className="payee-payrol-container">
                                                    <div className="payee-payrol-details-box">
                                                        <div className="payee-name">{selectedPayeePayrols?.name}</div>
                                                        <div className="payee-dues">Total: ${selectedPayeeAmount}</div>
                                                        <div className="pay-button">
                                                            <button type="button" className="pay-btn" style={!selectedPayeeToPay.length ? calenderStyles.disabledBtn : {}} onClick={callPayeePayApi}>
                                                                {isPayeePaying && (<Spin indicator={antIcon} />)} Pay
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {selectedPayeePayrols?.payroll && Object.keys(selectedPayeePayrols?.payroll).length ? (
                                                        <Row gutter={[20, 20]} className="payee-payrol-pay-container">
                                                            {Object.keys(selectedPayeePayrols?.payroll)?.map((pays) =>
                                                                <PayRolePayCard ref={refPayRoleCard} isSmall={isSmallScreen} pays={selectedPayeePayrols?.payroll[pays]} selectedPayeeToPay={selectedPayeeToPay} handleCheckBoxAmount={handleCheckBoxAmount} />
                                                            )}
                                                        </Row>
                                                    ) : (<></>)}
                                                </div>
                                            ) : (<></>)}
                                        </div>
                                    ) : (<></>)}
                                </div>
                            ))}
                        </div>) : (<></>)}
                    </>
                )}
            </div>
        </Wrapper>
    );
};

export default PayRole;
